import { hideMessage, showMessage } from './store/message-actions';

export { createMessageMiddleware } from './store/message-middleware';

export const messageActions = {
  showMessage,
  hideMessage,
};
